/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import FilmCarousel from '../lists/FilmCarousel';

import styles from '../../../styles/cards/bundle.module.scss';

const propTypes = {
    item: AppPropTypes.film,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    className: null,
};

const BundleCard = ({ item, className }) => {
    const { title: bundleTitle = null, films: bundleFilms = null, url } = item || {};
    return bundleFilms !== null && bundleFilms.length > 0 ? (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <FilmCarousel
                title={bundleTitle}
                items={bundleFilms}
                link={url}
                theme="bundle"
                isDark
            />
        </div>
    ) : null;
};

BundleCard.propTypes = propTypes;
BundleCard.defaultProps = defaultProps;

export default BundleCard;
